import { AdmissionVisitTypes } from '../enums';
import { SelectItem } from 'primeng/api';

export class AdmissionVisitTypeLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'New Visit', value: AdmissionVisitTypes.NewVisit },
            { label: 'Followup Visit', value: AdmissionVisitTypes.FollowupVisit },
            { label: 'Other', value: AdmissionVisitTypes.Other },
        ];
    }
}
